import { render } from "./HonorPage.vue?vue&type=template&id=69d388d5"
import script from "./HonorPage.vue?vue&type=script&lang=js"
export * from "./HonorPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__